import type { CSSProperties } from 'react';

export type CategoryChipProps = {
  label: string;
  on?: boolean;
  onClick?: () => void;
};

/** Chip de categoria (`.chips button`); `on` = selecionado, com ✓. */
export function CategoryChip({ label, on = false, onClick }: CategoryChipProps) {
  return (
    <button type="button" className={on ? 'on' : ''} aria-pressed={on} onClick={onClick}>
      {on ? '✓ ' : ''}{label}
    </button>
  );
}

export type CategoryPickerProps = {
  options: readonly string[];
  /** Categoria atual (ex.: "Sem categoria" quando não está entre as opções). */
  value: string;
  onChange?: (category: string) => void;
  label?: string;
  style?: CSSProperties;
};

/** Escolha de categoria do lançamento (`.chips`). */
export function CategoryPicker({ options, value, onChange, label = 'Categoria', style }: CategoryPickerProps) {
  return (
    <div className="chips" role="group" aria-label={label} style={style}>
      {options.map((c) => (
        <CategoryChip key={c} label={c} on={value === c} onClick={() => onChange?.(c)} />
      ))}
    </div>
  );
}
